import React, { useState, useEffect } from 'react';
import axios from '../../utils/axiosInstance';
import CommonForm from '../../components/commonComponent/CommonForm';
import { validateForm } from '../../utils/formUtils';
import { toastSuccess, toastError } from '../../utils/alertHelper';
import { useNavigate, useParams } from "react-router-dom";
import MapPickerModal from '../../components/commonComponent/MapPickerModal';

const Usercreate = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState('basic');
  const navigate = useNavigate();
  const [mapVisible, setMapVisible] = useState(false);
  const [selectedBusinessIndex, setSelectedBusinessIndex] = useState(null);
  const [businessDropdowns, setBusinessDropdowns] = useState([{ states: [], cities: [] }]);
  const [formValues, setFormValues] = useState({
    businesses: [
      {
        business_name: '',
        primary_business: false,
        business_established_date: '',
        business_type: '',
        business_category: '',
        business_sub_category: '',
        business_formation: '',
        business_product_service: '',
        team_size: '',
        business_email: '',
        mobile: '',
        gst_number: '',
        website_url: '',
        business_description: '',
        logo: null,
        banner: null,
        gstImage: null,
        address: '',
        country: localStorage.getItem("defaultCountry"),
        state: localStorage.getItem("defaultState"),
        city: localStorage.getItem("defaultCity"),
        latitude: '',
        longitude: '',
        instagram: '',
        google_profile: '',
        youtube: '',
        linkedin: '',
        facebook: '',
      },
    ],
    profilepic: null,
    firstName: '',
    middleName: '',
    lastName: '',
    email: '',
    password: '',
    mobileNumber: '',
    dob: '',
    anniversaryDate: '',
    bloodGroup: '',
    gender: 'Male',
    roleId: [],
    cluster: [],
    chapter: [],
    responsibilities: [],
    address: '',
    aadharCard: '',
    panCard: '',
    userType: 'Member',
    country: localStorage.getItem("defaultCountry"),
    state: localStorage.getItem("defaultState"),
    city: localStorage.getItem("defaultCity"),
    pincode: '',
    latitude: '',
    longitude: '',
    wifeName: '',
    wifeDob: '',
    children: [{ name: '', dob: '', gender: '' }],
    emergencyContactName: '',
    emergencyContactMobile: '',
  });

  const [dropdowns, setDropdowns] = useState({
    roles: [], clusters: [], chapters: [], responsibilities: [],
    businessTypes: [], businessCategories: [], businessSubCategories: [], businessFormations: [], businessProductServices: [],
    countries: [], states: [], cities: [],
    businessStates: [], businessCities: []
  });

  const [rawCountriesData, setRawCountriesData] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // Load static dropdowns (roles, clusters, etc.) and countries
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [
          rolesRes, clustersRes, chaptersRes, responsibilitiesRes,
          businessTypesRes, businessCategoriesRes, businessSubCategoriesRes, businessFormationsRes, businessProductServicesRes,
          countryRes,stateRes,cityRes
        ] = await Promise.all([
          axios.get('/admin/api/role'),
          axios.get('/admin/api/clusters/all'),
          axios.get('/admin/api/chapters/all'),
          axios.get('/admin/api/responsibility/all'),
          axios.get('/admin/api/businessType'),
          axios.get('/admin/api/businessCategory'),
          axios.get('/admin/api/businessSubCategory'),
          axios.get('/admin/api/businessFormation'),
          axios.get('/admin/api/productOrService'),
          axios.get('/admin/api/country'),
          axios.get('/admin/api/state'),
          axios.get('/admin/api/city')
        ]);
        const countries = countryRes.data?.countries || [];
        const states = stateRes.data?.states || [];
        const cities = cityRes.data?.cities || [];
        setRawCountriesData(countries);
        setDropdowns(prev => ({
          ...prev,
          businessTypes: businessTypesRes.data?.businessTypes?.map(bt => ({ value: bt._id, label: bt.name })) || [],
          businessCategories: businessCategoriesRes.data?.businessCategories?.map(bc => ({ value: bc._id, label: bc.name })) || [],
          businessSubCategories: businessSubCategoriesRes.data?.businessSubCategories?.map(bsc => ({ value: bsc._id, label: bsc.name })) || [],
          businessFormations: businessFormationsRes.data?.businessFormations?.map(bf => ({ value: bf._id, label: bf.name })) || [],
          businessProductServices: businessProductServicesRes.data?.productOrServices?.map(bps => ({ value: bps._id, label: bps.name })) || [],
          roles: rolesRes.data?.roles?.map(r => ({ value: r._id, label: r.name })) || [],
          clusters: clustersRes.data?.cluster?.map(c => ({ value: c._id, label: c.name })) || [],
          chapters: chaptersRes.data?.chapter?.map(ch => ({ value: ch._id, label: ch.name })) || [],
          responsibilities: responsibilitiesRes.data?.responsibility?.map(res => ({ value: res._id, label: res.name })) || [],
          countries: countries.map(c => ({ value: c._id, label: c.name })),
          states: states.map(s => ({ value: s._id, label: s.name })),
          cities: cities.map(c => ({ value: c._id, label: c.name })),
        }));
      } catch (error) {
        toastError('Failed to load dropdown data');
      }
    };

    fetchDropdownData();
  }, []);

  // Fetch states by country
  const fetchStatesByCountry = async (countryId, isForBusiness = false) => {
    try {
      const response = await axios.get(`/admin/api/state?countryId=${countryId}`);
      const states = response.data?.states || [];
      if (isForBusiness) {
        setDropdowns(prev => ({
          ...prev,
          businessStates: states.map(s => ({ value: s._id, label: s.name })),
          businessCities: [],
        }));
      } else {
        setDropdowns(prev => ({
          ...prev,
          states: states.map(s => ({ value: s._id, label: s.name })),
          cities: [],
        }));
      }
      return states;
    } catch (error) {
      toastError('Failed to load states');
      return [];
    }
  };

  // Fetch cities by state
  const fetchCitiesByState = async (stateId, isForBusiness = false) => {
    try {
      const response = await axios.get(`/admin/api/city?stateId=${stateId}`);
      const cities = response.data?.cities || [];
      if (isForBusiness) {
        setDropdowns(prev => ({
          ...prev,
          businessCities: cities.map(c => ({ value: c._id, label: c.name })),
        }));
      } else {
        setDropdowns(prev => ({
          ...prev,
          cities: cities.map(c => ({ value: c._id, label: c.name })),
        }));
      }
      return cities;
    } catch (error) {
      toastError('Failed to load cities');
      return [];
    }
  };

useEffect(() => {
  // Only run on create (not edit)
  if (id) return;

  // Default values
  const defaultCountry = localStorage.getItem("defaultCountry");
  const defaultState = localStorage.getItem("defaultState");

  // Only if there is a default country/state set
  if (defaultCountry) {
    fetchBusinessStatesByCountry(defaultCountry, 0);
    if (defaultState) {
      fetchBusinessCitiesByState(defaultState, 0);
    }
  }
}, [id]);

  // Edit mode: fetch user, then fetch states/cities for basic tab and business tabs
  useEffect(() => {
    if (!id) return;
    const fetchUser = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`/api/user/${id}`);
        const user = res.data.user;
        if (!user) throw new Error('User not found');

        // Fetch and set basic info dropdowns before setting form values
        let countryId = user.country?._id || '';
        let stateId = user.state?._id || '';
        let cityId = user.city?._id || '';

        // Fetch states/cities for basic tab
        if (countryId) {
          await fetchStatesByCountry(countryId, false);
        }
        if (stateId) {
          await fetchCitiesByState(stateId, false);
        }

        setFormValues(prev => ({
          ...prev,
          country: countryId,
          state: stateId,
          city: cityId,
          profilepic: user.profilepic || '',
          firstName: user.firstName || '',
          middleName: user.middleName || '',
          lastName: user.lastName || '',
          email: user.email || '',
          password: '',
          mobileNumber: user.mobileNumber || '',
          dob: user.dob ? user.dob.split('T')[0] : '',
          anniversaryDate: user.anniversaryDate ? user.anniversaryDate.split('T')[0] : '',
          bloodGroup: user.bloodGroup || '',
          gender: user.gender || 'Male',
          roleId: user.roles ? user.roles.map(r => r._id) : [],
          cluster: user.cluster ? user.cluster.map(r => r._id) : [],
          chapter: user.chapter ? user.chapter.map(r => r._id) : [],
          responsibilities: user.responsibilities ? user.responsibilities.map(r => r._id) : [],
          pincode: user.pincode || '',
          latitude: user.location?.coordinates ? user.location.coordinates[1] : (user.latitude || ''),
          longitude: user.location?.coordinates ? user.location.coordinates[0] : (user.longitude || ''),
          address: user.address || '',
          aadharCard: user.aadharCard || '',
          panCard: user.panCard || '',
          wifeName: user.wife ? user.wife.name : '',
          wifeDob: user.wife ? user.wife.dob.split('T')[0] : '',
          wife_contact: user.wife ? user.wife.mobileNumber : '',
          children: user.children && user.children.length
            ? user.children.map(child => ({
                name: child.name || child.childName || '',
                dob: child.dob ? child.dob.split('T')[0] : child.childdob || '',
                gender: child.gender || child.childgender || '',
              }))
            : [{ name: '', dob: '', gender: '' }],
          emergencyContactName: user.emergencyContactName || '',
          emergencyContactMobile: user.emergencyContactMobile || '',
          businesses: user.business && user.business.length > 0
            ? user.business.map(biz => ({
                business_name: biz.name || biz.businessName || '',
                primary_business: biz.primaryBusiness || false,
                business_established_date: biz.establishedDate ? biz.establishedDate.split('T')[0] : (biz.businessEstablishedDate ? biz.businessEstablishedDate.split('T')[0] : ''),
                business_type: biz.type ? biz.type._id : (biz.businessType ? biz.businessType._id : ''),
                business_category: biz.category ? biz.category._id : (biz.businessCategory ? biz.businessCategory._id : ''),
                business_sub_category: biz.subCategory ? biz.subCategory._id : (biz.businessSubCategory ? biz.businessSubCategory._id : ''),
                business_formation: biz.formation ? biz.formation._id : (biz.businessFormation ? biz.businessFormation._id : ''),
                business_product_service: biz.productsOrServices ? biz.productsOrServices._id : '',
                team_size: biz.teamSize || '',
                business_email: biz.email || biz.businessEmail || '',
                mobile: biz.number || biz.businessMobileNumber || '',
                gst_number: biz.gstNumber || '',
                website_url: biz.websiteURL || '',
                business_description: biz.description || biz.businessDescription || '',
                logo: biz.logo || '',
                banner: biz.banner || '',
                gstImage: biz.gstImage || '',
                address: biz.address || '',
                country: biz.country ? biz.country._id : localStorage.getItem("defaultCountry"),
                state: biz.state ? biz.state._id : localStorage.getItem("defaultState"),
                city: biz.city ? biz.city._id : localStorage.getItem("defaultCity"),
                latitude: biz.location?.coordinates ? biz.location.coordinates[1] : '',
                longitude: biz.location?.coordinates ? biz.location.coordinates[0] : '',
                instagram: biz.socialMedia?.instagram || '',
                google_profile: biz.socialMedia?.googleProfile || '',
                youtube: biz.socialMedia?.youtube || '',
                linkedin: biz.socialMedia?.linkedin || '',
                facebook: biz.socialMedia?.facebook || '',
              }))
            : prev.businesses,
        }));

        // For each business tab, fetch states/cities for dropdowns
        if (user.business && user.business.length > 0) {
          const dropdownArr = [];
          for (let i = 0; i < user.business.length; i++) {
            dropdownArr.push({ states: [], cities: [] });
          }
          setBusinessDropdowns(dropdownArr);

          for (let i = 0; i < user.business.length; i++) {
            const biz = user.business[i];
            if (biz.country?._id || biz.country) {
              await fetchBusinessStatesByCountry(biz.country?._id || biz.country, i);
              if (biz.state?._id || biz.state) {
                await fetchBusinessCitiesByState(biz.state?._id || biz.state, i);
              }
            }
          }
        }
      } catch (error) {
        toastError('Failed to fetch user data');
        navigate('/user');
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, [id, navigate]);

  // Business dropdowns fetch
  const fetchBusinessStatesByCountry = async (countryId, index) => {
    try {
      const response = await axios.get(`/admin/api/state?countryId=${countryId}`);
      const states = response.data?.states || [];
      setBusinessDropdowns(prev => {
        const updated = [...prev];
        updated[index] = { ...updated[index], states: states.map(s => ({ value: s._id, label: s.name })), cities: [] };
        return updated;
      });
    } catch (error) {
      toastError('Failed to load states');
    }
  };

  const fetchBusinessCitiesByState = async (stateId, index) => {
    try {
      const response = await axios.get(`/admin/api/city?stateId=${stateId}`);
      const cities = response.data?.cities || [];
      setBusinessDropdowns(prev => {
        const updated = [...prev];
        updated[index] = { ...updated[index], cities: cities.map(c => ({ value: c._id, label: c.name })) };
        return updated;
      });
    } catch (error) {
      toastError('Failed to load cities');
    }
  };

  const handleBusinessAddressChange = (fieldName, value, index) => {
    if (fieldName === 'country') {
      fetchBusinessStatesByCountry(value, index);
      setFormValues(prev => {
        const updatedBusinesses = [...prev.businesses];
        updatedBusinesses[index].state = '';
        updatedBusinesses[index].city = '';
        return { ...prev, businesses: updatedBusinesses };
      });
    }
    if (fieldName === 'state') {
      fetchBusinessCitiesByState(value, index);
      setFormValues(prev => {
        const updatedBusinesses = [...prev.businesses];
        updatedBusinesses[index].city = '';
        return { ...prev, businesses: updatedBusinesses };
      });
    }
  };

  const handleAddBusiness = async () => {
    const defaultCountry = localStorage.getItem("defaultCountry");
    const defaultState = localStorage.getItem("defaultState");
    const defaultCity = localStorage.getItem("defaultCity");
    setFormValues(prev => ({
      ...prev,
      businesses: [
        ...prev.businesses,
        {
          business_name: '',
          primary_business: false,
          business_established_date: '',
          business_type: '',
          business_category: '',
          business_sub_category: '',
          business_formation: '',
          business_product_service: '',
          team_size: '',
          business_email: '',
          mobile: '',
          gst_number: '',
          website_url: '',
          business_description: '',
          logo: null,
          banner: null,
          gstImage: null,
          address: '',
          country: defaultCountry,
          state: defaultState,
          city: defaultCity,
          latitude: '',
          longitude: '',
          instagram: '',
          google_profile: '',
          youtube: '',
          linkedin: '',
          facebook: '',
        },
      ],
    }));
    setBusinessDropdowns(prev => ([...prev, { states: [], cities: [] }]));
    const newIndex = formValues.businesses.length;
    if (defaultCountry) {
      await fetchBusinessStatesByCountry(defaultCountry, newIndex);
      if (defaultState) {
        await fetchBusinessCitiesByState(defaultState, newIndex);
      }
    }
  };

  const handleRemoveBusiness = (index) => {
    setFormValues(prev => {
      const updated = [...prev.businesses];
      updated.splice(index, 1);
      return { ...prev, businesses: updated };
    });
    setBusinessDropdowns(prev => {
      const updated = [...prev];
      updated.splice(index, 1);
      return updated;
    });
  };

  // PATCH: handle country/state changes for basic info
  const handleBasicChange = async (updated) => {
    let changed = false;
    if (updated.country && updated.country !== formValues.country) {
      await fetchStatesByCountry(updated.country, false);
      setFormValues(prev => ({
        ...prev,
        country: updated.country,
        state: '',
        city: '',
      }));
      changed = true;
    }
    if (updated.state && updated.state !== formValues.state) {
      await fetchCitiesByState(updated.state, false);
      setFormValues(prev => ({
        ...prev,
        state: updated.state,
        city: '',
      }));
      changed = true;
    }
    if (!changed) {
      setFormValues(prev => ({ ...prev, ...updated }));
    }
  };

  const handleSubmit = async () => {
    const isEdit = !!id;
    const validationRules = {
      email: { required: true },
      firstName: { required: true },
      lastName: { required: true },
      middleName: { required: true },
      mobileNumber: { required: true, mobile: true },
      mobile: { mobile: true },
      emergencyContactMobile: { mobile: true },
      gst_number: { uppercase: true },
      ...(isEdit ? {} : { password: { required: true } }),
      ...(formValues.address && formValues.address.trim() !== ''
        ? {
            country: { required: true },
            state: { required: true },
            city: { required: true },
          }
        : {}),
    };

    const validationErrors = validateForm(formValues, validationRules);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      const errorFields = Object.keys(validationErrors);
      if (errorFields.some(f => ['firstName', 'middleName', 'lastName', 'email', 'mobileNumber', 'dob', 'gender', 'bloodGroup', 'password', 'address', 'cluster', 'chapter', 'responsibilities', 'state', 'city', 'country'].includes(f))) {
        setActiveTab('basic');
      } else if (errorFields.some(f => ['wifeName', 'wifeDob', 'wife_contact', 'emergencyContactName', 'emergencyContactMobile', 'children'].includes(f))) {
        setActiveTab('family');
      } else if (errorFields.some(f => ['gst_number', 'business_name', 'mobile', 'business_email', 'latitude', 'longitude'].includes(f))) {
        setActiveTab('business');
      }
      return;
    }

    try {
      const businessData = Array.isArray(formValues.businesses)
        ? formValues.businesses
            .filter((biz) => biz.business_name && biz.business_name.trim() !== '')
            .map((biz) => ({
              name: biz.business_name || '',
              primaryBusiness: biz.primary_business || false,
              establishedDate: biz.business_established_date || '',
              type: Array.isArray(biz.business_type) ? biz.business_type.join(',') : biz.business_type || '',
              category: Array.isArray(biz.business_category) ? biz.business_category.join(',') : biz.business_category || '',
              subCategory: Array.isArray(biz.business_sub_category) ? biz.business_sub_category.join(',') : biz.business_sub_category || '',
              formation: Array.isArray(biz.business_formation) ? biz.business_formation.join(',') : biz.business_formation || '',
              productsOrServices: Array.isArray(biz.business_product_service) ? biz.business_product_service.join(',') : biz.business_product_service || '',
              teamSize: biz.team_size || '',
              email: biz.business_email?.trim() || '',
              number: biz.mobile || '',
              gstNumber: biz.gst_number || '',
              websiteURL: biz.website_url || '',
              description: biz.business_description || '',
              socialMedia: {
                instagram: biz.instagram || '',
                googleProfile: biz.google_profile || '',
                youtube: biz.youtube || '',
                linkedin: biz.linkedin || '',
                facebook: biz.facebook || '',
              },
              address: biz.address || '',
              country: biz.country || '',
              state: biz.state || '',
              city: biz.city || '',
              latitude:  biz.latitude || '',
              longitude: biz.longitude || '',
            }))
        : [];

      const formData = new FormData();
      formData.append('roleId', Array.isArray(formValues.roleId) ? formValues.roleId.join(',') : formValues.roleId || '');
      formData.append('cluster', Array.isArray(formValues.cluster) ? formValues.cluster.join(',') : formValues.cluster || '');
      formData.append('chapter', Array.isArray(formValues.chapter) ? formValues.chapter.join(',') : formValues.chapter || '');
      formData.append('responsibilities', Array.isArray(formValues.responsibilities) ? formValues.responsibilities.join(',') : formValues.responsibilities || '');

      formData.append('wife', formValues.wifeName
        ? JSON.stringify({
            name: formValues.wifeName || '',
            dob: formValues.wifeDob || '',
            mobileNumber: formValues.wife_contact || '',
          })
        : '');

      const validChildren = (formValues.children || []).filter(
        (child) =>
          (child.name && child.name.trim() !== '') ||
          (child.dob && child.dob.trim() !== '') ||
          (child.gender && child.gender.trim() !== '')
      );
      formData.append('children', validChildren.length > 0
        ? JSON.stringify(validChildren.map((child) => ({
            name: child.name || '',
            dob: child.dob || '',
            gender: child.gender || '',
          })))
        : '');

      formData.append('business', JSON.stringify(businessData));
      formValues.businesses.forEach((business, index) => {
        if (business.logo instanceof File) {
          formData.append(`businesses[${index}][logo]`, business.logo);
        }
        if (business.banner instanceof File) {
          formData.append(`businesses[${index}][banner]`, business.banner);
        }
        if (business.gstImage instanceof File) {
          formData.append(`businesses[${index}][gstImage]`, business.gstImage);
        }
      });
      for (const key in formValues) {
        if (
          ['roleId', 'cluster', 'chapter', 'responsibilities', 'wifeName', 'wifeDob', 'wife_contact', 'children', 'businesses'].includes(key)
        )
          continue;
        const value = formValues[key];
        if (value instanceof File) {
          formData.append(key, value);
        } else if (typeof value === 'object' && value !== null) {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value ?? '');
        }
      }

      const config = { headers: { 'Content-Type': 'multipart/form-data' } };
      if (isEdit) {
        await axios.put(`/api/user/${id}`, formData, config);
        toastSuccess('User updated successfully!');
      } else {
        await axios.post('/api/user/create', formData, config);
        toastSuccess('User created successfully!');
      }
      navigate('/user');
    } catch (error) {
      toastError('Failed to save user');
    }
  };

  const handleCancel = () => {
    setFormValues({
      businesses: [
        {
          business_name: '',
          primary_business: false,
          business_established_date: '',
          business_type: '',
          business_category: '',
          business_sub_category: '',
          business_formation: '',
          business_product_service: '',
          team_size: '',
          business_email: '',
          mobile: '',
          gst_number: '',
          website_url: '',
          business_description: '',
          logo: null,
          banner: null,
          gstImage: null,
          address: '',
          country: '',
          state: '',
          city: '',
          latitude: '',
          longitude: '',
          instagram: '',
          google_profile: '',
          youtube: '',
          linkedin: '',
          facebook: '',
        },
      ],
      profilepic: null,
      firstName: '',
      middleName: '',
      lastName: '',
      email: '',
      password: '',
      mobileNumber: '',
      dob: '',
      anniversaryDate: '',
      bloodGroup: '',
      gender: 'Male',
      roleId: [],
      cluster: [],
      chapter: [],
      responsibilities: [],
      country: '',
      state: '',
      city: '',
      pincode: '',
      latitude: '',
      longitude: '',
      address: '',
      aadharCard: '',
      panCard: '',
      wifeName: '',
      wifeDob: '',
      wife_contact: '',
      children: [{ name: '', dob: '', gender: '' }],
      emergencyContactName: '',
      emergencyContactMobile: '',
    });
    setErrors({});
    setDropdowns(prev => ({
      ...prev,
      states: [],
      cities: [],
      businessStates: [],
      businessCities: [],
    }));
  };

  const tabs = [
    { id: 'basic', label: 'Basic Info' },
    { id: 'family', label: 'Family Info' },
    { id: 'business', label: 'Business Info' },
  ];

  // PATCH: handle password hide and email readonly in edit mode
  const isEdit = !!id;
  const fieldSets = {
    basic: [
      {
        section: 'Profile',
        fields: [
          { name: 'profilepic', label: 'Profile Pic', placeholder: 'Profile Pic', type: 'file' },
        ],
      },
      {
        section: 'Personal Details',
        fields: [
          { name: 'firstName', label: 'First Name', placeholder: 'First Name', type: 'text', required: true },
          { name: 'middleName', label: 'Middle Name', placeholder: 'Middle Name', type: 'text', required: true },
          { name: 'lastName', label: 'Last Name', placeholder: 'Last Name', type: 'text', required: true },
          { name: 'mobileNumber', label: 'Mobile Number', placeholder: 'Mobile Number', type: 'phoneWithCountry' },
          { name: 'dob', label: 'Birthdate', placeholder: 'Birthdate', type: 'date' },
          { name: 'anniversaryDate', label: 'Anniversary Date', placeholder: 'Anniversary Date', type: 'date' },
          { name: 'bloodGroup', label: 'Blood Group', placeholder: 'Blood Group', type: 'text' },
          {
            name: 'gender',
            label: 'Gender',
            placeholder: 'Select Gender',
            type: 'radio',
            options: [
              { value: 'Male', label: 'Male' },
              { value: 'Female', label: 'Female' },
            ],
          },
        ],
      },
      {
        section: 'Membership',
        fields: [
          { name: 'chapter', label: 'Chapter', placeholder: 'Chapter', type: 'select', isMulti: true, options: dropdowns.chapters },
          { name: 'cluster', label: 'Cluster', placeholder: 'Cluster', type: 'select', isMulti: true, options: dropdowns.clusters },
          { name: 'roleId', label: 'Role', placeholder: 'Role', type: 'select', isMulti: true, options: dropdowns.roles },
          { name: 'responsibilities', label: 'Responsibilities', placeholder: 'Responsibilities', type: 'select', isMulti: true, options: dropdowns.responsibilities },
        ],
      },
      {
        section: 'Address',
        fields: [
          { name: 'address', label: 'Residential Address', placeholder: 'Residential Address', type: 'textarea', rows: 2 },
          {
            name: 'country',
            label: 'Country',
            placeholder: 'Select Country',
            type: 'select',
            options: dropdowns.countries,
          },
          {
            name: 'state',
            label: 'State',
            placeholder: 'Select State',
            type: 'select',
            options: dropdowns.states,
          },
          {
            name: 'city',
            label: 'City',
            placeholder: 'Select City',
            type: 'select',
            options: dropdowns.cities,
          },
          { name: 'pincode', label: 'Pincode', type: 'text' },
          { name: 'basicLocation', label: 'Location (GPS)', placeholder: 'Click to select location', type: 'basicLocation' },
        ],
      },
      {
        section: 'Documents',
        fields: [
          { name: 'panCard', label: 'PAN Card', placeholder: 'PAN Card', type: 'file' },
          { name: 'aadharCard', label: 'Aadhar Card', placeholder: 'Aadhar Card', type: 'file' },
        ],
      },
      {
        section: 'Login',
        fields: [
          {
            name: 'email',
            label: 'Email ID',
            placeholder: 'Email ID',
            type: 'email',
            readOnly: isEdit, // PATCH: email readonly in edit
          },
          ...(!isEdit
            ? [{
                name: 'password',
                label: 'Password',
                placeholder: 'Password',
                type: 'password',
                required: true,
              }]
            : []),
        ],
      },
    ],
    business: [
      {
        section: 'Business Details',
        fields: [
          {
            name: 'businesses',
            type: 'group',
            fields: [
              { name: 'business_name', label: 'Company Name', placeholder: 'Company Name', type: 'text' },
              { name: 'primary_business', label: 'Primary Business', placeholder: 'Primary Business', type: 'checkbox' },
              { name: 'business_established_date', label: 'Business Established Date', placeholder: 'Business Established Date', type: 'date' },
              {
                name: 'business_type',
                label: 'Business Type',
                placeholder: 'Select Business Type',
                type: 'select',
                options: dropdowns.businessTypes,
              },
              {
                name: 'business_category',
                label: 'Business Category',
                placeholder: 'Select Business Category',
                type: 'select',
                options: dropdowns.businessCategories,
              },
              {
                name: 'business_sub_category',
                label: 'Business Sub Category',
                placeholder: 'Select Business Sub Category',
                type: 'select',
                options: dropdowns.businessSubCategories,
              },
              {
                name: 'business_formation',
                label: 'Business Formation',
                placeholder: 'Select Business Formation',
                type: 'select',
                options: dropdowns.businessFormations,
              },
              {
                name: 'business_product_service',
                label: 'Business Product & Service',
                placeholder: 'Select Business Product & Service',
                type: 'select',
                options: dropdowns.businessProductServices,
              },
              { name: 'team_size', label: 'Team Size', placeholder: 'Team Size', type: 'number' },
              { name: 'business_email', label: 'Business Email', placeholder: 'Business Email ID', type: 'email' },
              { name: 'mobile', label: 'Contact Number', placeholder: 'Contact Number', type: 'number' },
              { name: 'gst_number', label: 'GST Number', placeholder: 'GST Number', type: 'text' },
              { name: 'website_url', label: 'Website URL', placeholder: 'Website URL', type: 'text' },
              { name: 'business_description', label: 'Business Description', placeholder: 'Business Description', type: 'textarea', rows: 2 },
              { name: 'logo', label: 'Upload Logo', placeholder: 'Upload Logo', type: 'file' },
              { name: 'banner', label: 'Upload Banner', placeholder: 'Upload Banner', type: 'file' },
              { name: 'gstImage', label: 'Upload GST Certificate', placeholder: 'Upload GST Certificate', type: 'file' },
              { name: 'address', label: 'Business Address', placeholder: 'Business Address', type: 'textarea', rows: 2 },
              {
                name: 'country',
                label: 'Country',
                placeholder: 'Select Country',
                type: 'select',
                options: dropdowns.countries,
              },
              {
                name: 'state',
                label: 'State',
                placeholder: 'Select State',
                type: 'select',
                options: dropdowns.businessStates,
              },
              {
                name: 'city',
                label: 'City',
                placeholder: 'Select City',
                type: 'select',
                options: dropdowns.businessCities,
              },
              { name: 'latitude', label: 'Latitude', placeholder: 'Latitude', type: 'text' },
              { name: 'longitude', label: 'Longitude', placeholder: 'Longitude', type: 'text' },
              { name: 'instagram', label: 'Instagram', placeholder: 'Instagram', type: 'text' },
              { name: 'google_profile', label: 'Google Profile', placeholder: 'Google Profile', type: 'text' },
              { name: 'youtube', label: 'YouTube', placeholder: 'YouTube', type: 'text' },
              { name: 'linkedin', label: 'LinkedIn', placeholder: 'LinkedIn', type: 'text' },
              { name: 'facebook', label: 'Facebook', placeholder: 'Facebook', type: 'text' },
            ],
          },
        ],
      },
    ],
    family: [
      { name: 'wifeName', label: 'Spouce Name', placeholder: 'Spouce Name', type: 'text' },
      { name: 'wifeDob', label: 'Spouce DOB', placeholder: 'Spouce DOB', type: 'date' },
      { name: 'wife_contact', label: 'Contact Number', placeholder: 'Contact Number', type: 'number' },
      { name: 'children', label: 'Children', placeholder: 'Children', type: 'group' },
      { name: 'emergencyContactName', label: 'Emergency Contact Name', placeholder: 'Emergency Contact Name', type: 'text' },
      { name: 'emergencyContactMobile', label: 'Emergency Contact Number', placeholder: 'Emergency Contact Number', type: 'number' },
    ],
  };

  if (loading) return <div>Loading user data...</div>;

  return (
    <div className="container mt-4">
      <h4 className="mb-3 text-dark border-bottom pb-2">{id ? 'Edit User & Business' : 'User & Business Registration'}</h4>
      <ul className="nav nav-tabs mb-4">
        {tabs.map((tab) => (
          <li className="nav-item" key={tab.id}>
            <button
              className={`nav-link ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          </li>
        ))}
      </ul>
      <CommonForm
        title={tabs.find((tab) => tab.id === activeTab).label}
        fields={fieldSets[activeTab]}
        values={formValues}
        onBusinessAddressChange={handleBusinessAddressChange}
        businessDropdowns={businessDropdowns}
        onChange={handleBasicChange}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        errors={errors}
        requiredFields={['email', 'mobileNumber','firstName','middleName','lastName','gst_number',...(isEdit ? [] : ['password'])]}
        submitLabel={isEdit ? 'Update' : 'Save'}
        cancelLabel="Reset"
        countriesData={dropdowns.countries}
        rawCountriesData={rawCountriesData}
        openMapPicker={(target) => {
          if (target === 'basic') {
            setSelectedBusinessIndex(null);
          } else {
            setSelectedBusinessIndex(target);
          }
          setMapVisible(true);
        }}
      />
      <MapPickerModal
        visible={mapVisible}
        onClose={() => setMapVisible(false)}
        onSave={(position) => {
          if (selectedBusinessIndex === null) {
            setFormValues({
              ...formValues,
              latitude: position.lat.toFixed(6),
              longitude: position.lng.toFixed(6),
            });
          } else {
            const updatedBusinesses = [...formValues.businesses];
            updatedBusinesses[selectedBusinessIndex].latitude = position.lat.toFixed(6);
            updatedBusinesses[selectedBusinessIndex].longitude = position.lng.toFixed(6);
            setFormValues({ ...formValues, businesses: updatedBusinesses });
          }
          setMapVisible(false);
        }}
        initialPosition={
          selectedBusinessIndex === null
            ? formValues.latitude && formValues.longitude
              ? [parseFloat(formValues.latitude), parseFloat(formValues.longitude)]
              : null
            : selectedBusinessIndex !== null &&
              formValues.businesses[selectedBusinessIndex]?.latitude &&
              formValues.businesses[selectedBusinessIndex]?.longitude
                ? [
                    parseFloat(formValues.businesses[selectedBusinessIndex].latitude),
                    parseFloat(formValues.businesses[selectedBusinessIndex].longitude),
                  ]
                : null
        }
      />
    </div>
  );
};

export default Usercreate;